import { SVButton } from '@/components/core';
import DocumentLinkControl from '@/components/programSettings/documentLinks/DocumentLinkControls';
import SettingsControlPanel from '@/components/programSettings/SettingsControlPanel';
import { PROGRAM_SETTINGS } from '@/constants/programSettings';
import { Stack, Typography } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { useProgramSettingsForm } from '@/hooks/useProgramSettingsForm';

export default function ProgramSettingsDocumentLinks() {
  const { formMethods, handleSubmitSetting, isFormDirty } =
    useProgramSettingsForm();
  const { DOCUMENT_LINKS_SETTINGS_HEADER } = PROGRAM_SETTINGS;
  const { LABEL } = PROGRAM_SETTINGS.DOCUMENT_LINKS_INDEX_FACT_SHEET;

  return (
    <>
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(handleSubmitSetting)}>
          <Stack spacing={3} mb={3}>
            <Typography variant="h4" fontWeight="bold">
              {DOCUMENT_LINKS_SETTINGS_HEADER}
            </Typography>
            <SettingsControlPanel controlGroupTitle={LABEL}>
              <DocumentLinkControl />
            </SettingsControlPanel>
          </Stack>
          <Stack direction="row" spacing={3} justifyContent="flex-start">
            <SVButton type="submit" variant="primary" disabled={!isFormDirty}>
              Save
            </SVButton>
          </Stack>
        </form>
      </FormProvider>
    </>
  );
}
